module.exports = __webpack_public_path__ + "img/basket-placeholder.2ae37dd.png";